import { FormattedMessage } from 'react-intl';

import styles from '@components/buttons/Tab.module.css';
import Icon from '@components/text/Icon';
import { IconName } from '@utils/iconUtils';

type Props = {
  active: boolean;
  icon?: IconName | null;
  onClick?: () => void;
  text?: string;
  textKey?: string;
};

const Tab = ({ active, icon, onClick, text, textKey }: Props) => (
  <div className={`${styles.tab} ${active ? styles.active : ''}`} onClick={onClick}>
    <div className={styles.tabText}>
      {icon && <Icon color="primary" icon={icon} />}
      {text ? <>{text}</> : <FormattedMessage id={textKey} />}
    </div>
    <div className={styles.activeIndicator} />
  </div>
);

export default Tab;
